/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

/* stylelint-disable scss/dollar-variable-colon-space-after */
.high-shadow {
  box-shadow: 0 24px 24px rgba(0, 0, 0, 0.08);
}

.primary-shadow {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
}

.secondary-shadow {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.04);
}

.purple-shadow {
  box-shadow: 0 0 4px 0 #e9e1f8;
}

.sharp-edge {
  border: #eaeaea 1px solid;
}

.background-blur-20 {
  backdrop-filter: blur(10px);
}

.button-glow-shadow {
  box-shadow: 0 0 12px #a6cddc;
}

@media (max-width: 575.98px) {
  .desktopOnly {
    display: none;
  }
}

.mobileOnly {
  display: none;
}
@media (max-width: 575.98px) {
  .mobileOnly {
    display: unset;
  }
}

.hidden {
  display: none;
}

:global(.SignupFeatureRow) {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
}
:global(.SignupFeatureRow) .icon {
  flex-shrink: 0;
  width: 24px;
}

:global(.SignupPage) {
  display: flex;
  flex-direction: row;
  gap: 0;
  min-height: calc(100vh - 75px);
  width: 100%;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) {
    flex-direction: column;
    max-height: calc(100vh - 273px + 16px);
    min-height: unset;
    overflow: visible;
  }
}
:global(.SignupPage) .buttonsContainer {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) .buttonsContainer {
    gap: 16px;
  }
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle {
  background: #747775;
  border-radius: 4px;
  color: #fff;
  display: flex;
  gap: 0;
  height: 40px;
  padding: 0 10px;
  width: 100%;
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle:hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
  background: #747775;
  color: #fff;
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle.disabled {
  background: #ccc;
  color: #a6a6a6;
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle.disabled:hover {
  background: #ccc;
  box-shadow: unset;
  color: #a6a6a6;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons :global(.ContinueWithGoogle) {
    flex-grow: 1;
  }
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons .emailButton.override.colorOverride {
    flex-grow: 1;
    padding: unset;
  }
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons .emailButton.override.colorOverride.lightestPurple {
    background: #e9e1f8;
    border: #5b1dc2 1px solid;
    transition: background-color 0.15s ease-in-out;
  }
}
:global(.SignupPage) .buttonsContainer .emailSection {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) .buttonsContainer .emailSection {
    display: none;
  }
  :global(.SignupPage) .buttonsContainer .emailSection.mobileExpanded {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
  }
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride {
  align-items: center;
  border: 1px solid #747775;
  color: #1f1f1f;
  display: flex;
  gap: 0;
  height: 40px;
  width: 100%;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride:hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
  border: 1px solid #747775;
  color: #1f1f1f;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride.disabled {
  border: 1px solid #ccc;
  color: #a6a6a6;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride.disabled:hover {
  border: 1px solid #ccc;
  box-shadow: unset;
  color: #a6a6a6;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride.disabled :global(.email-icon.btn-icon) path {
  stroke: #d6c7f0;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride :global(.email-icon.btn-icon) {
  padding: 0 10px 0 6px;
  position: relative;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride :global(.general-oauth-icon.btn-icon) {
  height: 24px;
  padding: 0 10px 0 6px;
  position: relative;
  width: 40px;
}

.marketingSection {
  align-items: center;
  background: linear-gradient(90deg, #e7f8ff 0%, #e3e1ff 100%);
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 64px;
  width: 100%;
}
@media (max-width: 575.98px) {
  .marketingSection {
    padding-top: 32px;
  }
}

.marketingHeader {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.marketingHeader.bold,
.marketingHeader .bold {
  font-weight: 600;
}
.marketingHeader {
  font-weight: 600;
  text-align: center;
  max-width: 448px;
  padding: 0 48px;
}
@media (max-width: 575.98px) {
  .marketingHeader {
    font-size: 18px;
    font-weight: normal;
    line-height: 150%;
  }
  .marketingHeader.bold,
  .marketingHeader .bold {
    font-weight: 600;
  }
  .marketingHeader {
    font-weight: 600;
    text-align: center;
  }
}

.marketingContent {
  align-items: center;
  display: flex;
  flex-direction: column;
}

@media (max-width: 575.98px) {
  .mobileOnlySpacer {
    height: 70px;
  }
}

.primaryIllustration {
  width: 100%;
}

.featureListContent {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 48px;
}

.bannerMobileTop, .banner {
  background: linear-gradient(90deg, #fdf0c6 0%, #ed5e5e 275%);
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 12px;
  width: 100%;
}
.bannerMobileTop:empty, .banner:empty {
  background: none;
  padding: 0;
}

.banner:empty {
  height: 8px;
}
@media (max-width: 575.98px) {
  .banner {
    display: none;
  }
}

.bannerMobileTop {
  display: none;
}
@media (max-width: 575.98px) {
  .bannerMobileTop {
    display: unset;
  }
}

.signupSection {
  width: 100%;
}

.signupOptionsContainer {
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 100%;
  width: 100%;
}
@media (max-width: 575.98px) {
  .signupOptionsContainer {
    background-color: #fff;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    bottom: 0;
    box-shadow: 0 -16px 16px 0 rgba(0, 0, 0, 0.08);
    gap: 16px;
    height: 196px;
    min-height: unset;
    padding: 24px;
    position: fixed;
    transition: height 0.15s ease-in-out;
  }
  .signupOptionsContainer.expanded {
    height: 324px;
    transition: height 0.15s ease-in-out;
  }
}

.signupOptionsContent {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 24px auto;
  max-width: 375px;
  min-width: 300px;
  width: 50%;
}
@media (max-width: 575.98px) {
  .signupOptionsContent {
    margin: 0 auto;
    width: 100%;
  }
}

.enterpriseLink {
  margin-top: -8px;
}

.disclaimer {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.disclaimer.bold,
.disclaimer .bold {
  font-weight: 600;
}
.disclaimer {
  text-align: center;
  bottom: 64px;
  color: #404040;
  padding: 0 64px 0 72px;
  position: absolute;
}
@media (max-width: 575.98px) {
  .disclaimer {
    font-family: "Red Hat Text", "Helvetica", sans-serif;
    font-size: 12px;
    font-weight: normal;
    line-height: 150%;
  }
  .disclaimer.bold,
  .disclaimer .bold {
    font-weight: 600;
  }
  .disclaimer {
    bottom: 16px;
  }
}

.link {
  color: #000;
  text-decoration: underline;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */